/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

/* stylelint-disable scss/dollar-variable-colon-space-after */
.high-shadow {
  box-shadow: 0 24px 24px rgba(0, 0, 0, 0.08);
}

.primary-shadow {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
}

.secondary-shadow {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.04);
}

.purple-shadow {
  box-shadow: 0 0 4px 0 #e9e1f8;
}

.sharp-edge {
  border: #eaeaea 1px solid;
}

.background-blur-20 {
  backdrop-filter: blur(10px);
}

.button-glow-shadow {
  box-shadow: 0 0 12px #a6cddc;
}

@media (max-width: 575.98px) {
  .desktopOnly {
    display: none;
  }
}

.mobileOnly {
  display: none;
}
@media (max-width: 575.98px) {
  .mobileOnly {
    display: unset;
  }
}

.hidden {
  display: none;
}

:global(.SignupFeatureRow) {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
}
:global(.SignupFeatureRow) .icon {
  flex-shrink: 0;
  width: 24px;
}

:global(.SignupPage) {
  display: flex;
  flex-direction: row;
  gap: 0;
  min-height: calc(100vh - 75px);
  width: 100%;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) {
    flex-direction: column;
    max-height: calc(100vh - 273px + 16px);
    min-height: unset;
    overflow: visible;
  }
}
:global(.SignupPage) .buttonsContainer {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) .buttonsContainer {
    gap: 16px;
  }
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle {
  background: #747775;
  border-radius: 4px;
  color: #fff;
  display: flex;
  gap: 0;
  height: 40px;
  padding: 0 10px;
  width: 100%;
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle:hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
  background: #747775;
  color: #fff;
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle.disabled {
  background: #ccc;
  color: #a6a6a6;
}
:global(.SignupPage) .buttonsContainer .ContinueWithGoogle.disabled:hover {
  background: #ccc;
  box-shadow: unset;
  color: #a6a6a6;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons :global(.ContinueWithGoogle) {
    flex-grow: 1;
  }
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons .emailButton.override.colorOverride {
    flex-grow: 1;
    padding: unset;
  }
  :global(.SignupPage) .buttonsContainer .mobileSignupButtons .emailButton.override.colorOverride.lightestPurple {
    background: #e9e1f8;
    border: #5b1dc2 1px solid;
    transition: background-color 0.15s ease-in-out;
  }
}
:global(.SignupPage) .buttonsContainer .emailSection {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 575.98px) {
  :global(.SignupPage) .buttonsContainer .emailSection {
    display: none;
  }
  :global(.SignupPage) .buttonsContainer .emailSection.mobileExpanded {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
  }
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride {
  align-items: center;
  border: 1px solid #747775;
  color: #1f1f1f;
  display: flex;
  gap: 0;
  height: 40px;
  width: 100%;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride:hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
  border: 1px solid #747775;
  color: #1f1f1f;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride.disabled {
  border: 1px solid #ccc;
  color: #a6a6a6;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride.disabled:hover {
  border: 1px solid #ccc;
  box-shadow: unset;
  color: #a6a6a6;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride.disabled :global(.email-icon.btn-icon) path {
  stroke: #d6c7f0;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride :global(.email-icon.btn-icon) {
  padding: 0 10px 0 6px;
  position: relative;
}
:global(.SignupPage) .buttonsContainer .emailButton.override.colorOverride :global(.general-oauth-icon.btn-icon) {
  height: 24px;
  padding: 0 10px 0 6px;
  position: relative;
  width: 40px;
}

.marketingSection {
  align-items: center;
  background: linear-gradient(90deg, #e7f8ff 0%, #e3e1ff 100%);
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 64px;
  width: 100%;
}
@media (max-width: 575.98px) {
  .marketingSection {
    padding-top: 32px;
  }
}

.marketingHeader {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.marketingHeader.bold,
.marketingHeader .bold {
  font-weight: 600;
}
.marketingHeader {
  font-weight: 600;
  text-align: center;
  max-width: 448px;
  padding: 0 48px;
}
@media (max-width: 575.98px) {
  .marketingHeader {
    font-size: 18px;
    font-weight: normal;
    line-height: 150%;
  }
  .marketingHeader.bold,
  .marketingHeader .bold {
    font-weight: 600;
  }
  .marketingHeader {
    font-weight: 600;
    text-align: center;
  }
}

.marketingContent {
  align-items: center;
  display: flex;
  flex-direction: column;
}

@media (max-width: 575.98px) {
  .mobileOnlySpacer {
    height: 70px;
  }
}

.primaryIllustration {
  width: 100%;
}

.featureListContent {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 48px;
}

.bannerMobileTop, .banner {
  background: linear-gradient(90deg, #fdf0c6 0%, #ed5e5e 275%);
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 12px;
  width: 100%;
}
.bannerMobileTop:empty, .banner:empty {
  background: none;
  padding: 0;
}

.banner:empty {
  height: 8px;
}
@media (max-width: 575.98px) {
  .banner {
    display: none;
  }
}

.bannerMobileTop {
  display: none;
}
@media (max-width: 575.98px) {
  .bannerMobileTop {
    display: unset;
  }
}

.signupSection {
  width: 100%;
}

.signupOptionsContainer {
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 100%;
  width: 100%;
}
@media (max-width: 575.98px) {
  .signupOptionsContainer {
    background-color: #fff;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    bottom: 0;
    box-shadow: 0 -16px 16px 0 rgba(0, 0, 0, 0.08);
    gap: 16px;
    height: 196px;
    min-height: unset;
    padding: 24px;
    position: fixed;
    transition: height 0.15s ease-in-out;
  }
  .signupOptionsContainer.expanded {
    height: 324px;
    transition: height 0.15s ease-in-out;
  }
}

.signupOptionsContent {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 24px auto;
  max-width: 375px;
  min-width: 300px;
  width: 50%;
}
@media (max-width: 575.98px) {
  .signupOptionsContent {
    margin: 0 auto;
    width: 100%;
  }
}

.enterpriseLink {
  margin-top: -8px;
}

.disclaimer {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.disclaimer.bold,
.disclaimer .bold {
  font-weight: 600;
}
.disclaimer {
  text-align: center;
  bottom: 64px;
  color: #404040;
  padding: 0 64px 0 72px;
  position: absolute;
}
@media (max-width: 575.98px) {
  .disclaimer {
    font-family: "Red Hat Text", "Helvetica", sans-serif;
    font-size: 12px;
    font-weight: normal;
    line-height: 150%;
  }
  .disclaimer.bold,
  .disclaimer .bold {
    font-weight: 600;
  }
  .disclaimer {
    bottom: 16px;
  }
}

.link {
  color: #000;
  text-decoration: underline;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */